'use strict';

/**
 * @ngdoc component
 * @name mx.shell:mxShellNavDropdownLevel
 * @module mx.shell
 * @description Shows Navigation Level as Dropdown (used for 4+ level(s))
 * @param {string} triggeringIcon@ - icon to open dropdown. If it is not defined, then `parentNavItem.title` will be used
 * @param {object} parentNavItem= - parent Navigation Item
 */

import template from './mx-shell-nav-dropdown-level.html';

export const mxShellNavDropdownLevelComponent = {
	bindings: {
		parentNavItem: '<',
		triggeringIcon: '@',
	},
	controller: MxShellNavDropdownLevelCtrl,
	controllerAs: 'vm',
	template,
};

MxShellNavDropdownLevelCtrl.$inject = ['$scope', '$element', 'mx.shell.EventService', 'mx.shell.NavigationService'];

function MxShellNavDropdownLevelCtrl($scope, $element, eventService, navigationService) {
	const vm = this;

	vm.$onInit = async function () {
		preloadNextLevelChildren(vm.parentNavItem);
	};

	vm.$postLink = function () {
		// ARIA optimization: allows to detect wrong possible focus position
		// similar to this: https://github.com/angular/material/issues/10075
		vm.isInsideDummyTab = !!$element.closest('md-dummy-tab').length;
		if (vm.isInsideDummyTab) {
			return;
		}

		// It's necessary to compile template here at once,
		// because <md-menu /> doesn't support recursive components call
		// and leads to strange sub-menus closing behaviors (#514196)
		vm.htmlTemplate = getHtmlTemplate(10);
	};

	$scope.$on('$mdMenuOpen', async function (menuScope) {
		await preloadNextLevelChildren(menuScope?.targetScope?.currentParentNavItem);
	});

	async function preloadNextLevelChildren(navItem) {
		const parentChildren = navItem?.children || [];
		await Promise.all(parentChildren.map((childItem) => navigationService.loadChildren(childItem)));
	}

	vm.handleOpenButtonKeypress = ($event) => {
		$event.stopPropagation();
		if ($event.which === 13 || $event.which === 32) {
			$($event.target).click();
		}
	};

	vm.handleItemClick = ($event, item) => {
		if (item.current) {
			return false;
		}
		eventService.dispatchEvent(mx.shell.EventCodes.BeforeNavigationItemClickHandler, item);
		eventService.dispatchEvent(mx.shell.EventCodes.TrackTelemetry, { eventName: `Navigation clicked`, sender: item.id, senderTitle: item.technicalName });

		let itemToBeOpen = item;
		while (!itemToBeOpen.route && itemToBeOpen.children?.length) {
			itemToBeOpen = itemToBeOpen.children[0];
		}

		navigationService
			.setCurrentNavigationItem(itemToBeOpen)
			.then(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemClicked, { navigationItem: itemToBeOpen, $event });
				setTimeout(() => {
					$('#DWP-main-content').trigger('focus');
				}, 100);
			})
			.catch(mx.logCatch);

		cleanUpDropdowns();
	};

	function cleanUpDropdowns() {
		setTimeout(() => {
			$('.md-open-menu-container:has(.mx-shell-nav-dropdown-level--container):visible').hide();
		}, 200);
	}

	function getHtmlTemplate(maxDropdownLevel) {
		const getSingleLevel = (n /* n - level Number */) => {
			const parent = n === 1 ? 'vm.parentNavItem' : `item${n - 1}`;
			const child = `item${n}`;
			return `
				<md-menu
					md-position-mode="${n === 1 ? 'target bottom' : 'cascade'}"
					ng-if=":: ${parent}.children.length > 0"
					ng-init="currentParentNavItem = ${parent}">
					<md-button
						ng-click="$mdMenu.open($event); ${n > 1 ? 'vm.handleItemClick($event, vm.parentNavItem);' : ''} $event.stopPropagation();"
						ng-keyup="vm.handleOpenButtonKeypress($event)"
						class="${n === 1 ? 'md-icon-button' : ''} mx-shell-nav-dropdown-level--open-btn"
						aria-label="{{ ${parent}.title }} {{'shell.mx-shell-nav.openSubmenuButton' | mxi18n}}"
						role="button">
						${n === 1 ? '<md-icon role="presentation">{{:: vm.triggeringIcon}}</md-icon>' : `<span>{{:: ${parent}.title }}</span>`}
						<div class="md-ripple-container"></div> <!-- without this JAWS won't read expanded list -->
					</md-button>
					<md-menu-content
						class="md-menu-bar-menu md-dense mx-shell-nav-dropdown-level--container"
						width="3">
						<md-menu-item
							ng-repeat="${child} in ${parent}.children | limitTo:100 track by ${child}.id"
							class="
								mx-shell-nav-dropdown-level--item
								{{(${child}.selected || ${child}.current) ? 'mx-shell-nav-dropdown-level--item-selected' : ''}}
							">
							<md-button
								ng-if=":: ${child}.children.length === 0"
								aria-current="{{${child}.activated ? 'page' : ${child}.selected ? 'true' : 'false'}}"
								ng-click="$event.stopPropagation(); vm.handleItemClick($event, ${child})">
								{{:: ${child}.title}}
							</md-button>

							<!--PLACEHOLDER_FOR_SUBMENU_RECURSION-->

						</md-menu-item>
					</md-menu-content>
				</md-menu>
			`;
		};
		let finalTemplate = getSingleLevel(1);
		for (let level = 2; level <= maxDropdownLevel; level++) {
			finalTemplate = finalTemplate.replace('<!--PLACEHOLDER_FOR_SUBMENU_RECURSION-->', getSingleLevel(level));
		}
		return finalTemplate.replace('<!--PLACEHOLDER_FOR_SUBMENU_RECURSION-->', '');
	}
}
